import React from 'react';
import { KitchenItemRequestProvider } from 'contexts/kitchen/item-request.context';
import KitchenItemRequestContent from './content';

const KitchenItemRequestLayout = () => {
  return (
    <KitchenItemRequestProvider>
      <KitchenItemRequestContent />
    </KitchenItemRequestProvider>
  );
};

export default KitchenItemRequestLayout;
